import TextField from "@mui/material/TextField";
import type { TextFieldProps as MuiTextFieldProps } from "@mui/material/TextField";

export function Input(props: MuiTextFieldProps) {
  return <TextField {...props} />;
} 